<template>
	<div>
		<el-container style="position: absolute;left: 0;top: 0;bottom: 0;right: 0; overflow: hidden;">
		  <el-header style="background:#fff;height: auto;z-index: 10;position: fixed;" :class="showAside ? 'left200' : 'left20'" class="wbig height240">
		 	<div style="width:100%;height:60px;position:absolute;background:rgb(251, 251, 251)" class="display"></div>
		  <div style="width:100%;align-items: center;" class="d-flex">
		  	  	<div class="mr-auto">
            <ul style="margin-top:5px !important;margin-bottom:0px !important">
		      	<li  class="nav-item absolute mt20" style="min-width:35px;margin-left:20px;"><el-button type="text" :icon="showAside ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="showNav"></el-button></li>
		      	<li  class="nav-item t-60">
		      		<a href="#">
		      			내 보유
            		<span class="badge badge-primary">{{formatMoney(mem_cash)}}</span>
		          </a>
		        </li>
		        <li  class="nav-item t-60"  @click="layClick3">
		      		<a href="javascript:;" >  			
          		내 포인트
            		<span class="badge badge-warning">{{formatMoney(mem_eventmoney)}}</span>
		          </a>
		        </li>
		        <li class="nav-item t-60">
		      		<a href="javascript:void(0)">
		      			카지노요율
            		<span class="badge badge-success">{{event_loing_recom_e !== '' ? event_loing_recom_e + '%' : ''}}</span>
		          </a>
		        </li>
		        <li class="nav-item t-60">
		      		<a href="javascript:void(0)">
		      			슬롯요율
            		<span class="badge badge-success">{{event_loing_recom_slot !== '' ? event_loing_recom_slot + '%' : ''}}</span>
		          </a>
		        </li>
		      <!--  <li  class="nav-item t-60" @click=""><a href="javascript:void(0)"> 유저보유<span class="badge badge-success">{{formatMoney(habu_apimoney)}}</span></a></li>
		        <li  class="nav-item t-60" @click=""><a href="javascript:void(0)">유저포인트<span class="badge badge-success">{{formatMoney(habu_event)}}</span></a></li>

              <li  class="nav-item t-60" @click=""><a href="javascript:void(0)">하부보유<span class="badge badge-default">{{formatMoney(pt_apimoney)}}</span></a></li>
            <li  class="nav-item t-60" @click=""><a href="javascript:void(0)">하부포인트<span class="badge badge-default">{{formatMoney(pt_event)}}</span></a></li>

            
		      -->


		        <li v-if="this.ulevel=='7'" class="nav-item t-60" @click=""><a href="javascript:void(0)">금일수수료<span class="badge badge-success">{{formatMoney(rogdd)}}</span></a></li>
		     
		      </ul>
          <audio id="ttsAudio" muted="muted"></audio>
           	

           </div>
           			<el-menu
			  :default-active="navBars.active"
			  mode="horizontal"
			  @select="handleSelect"
			  background-color="#fbfbfb"
			  text-color="#666"
			  active-text-color="#333" style="display: flex;" class="absolute topr">
			  <!-- <el-menu-item :index="index|numToString" v-for="(item,index) in navBars.list" :key="index">{{item.name}}</el-menu-item> -->
			 <el-submenu v-if="this.admin_id=='freedom'" index="10">
			  	 <template  slot="title">
			  	 	<div style="background:#2c3844;padding:0 10px;color:#ffd04b">{{$t('msg.언어전환')}}</div>
			  	 </template>
		       
		       <el-menu-item index="10-2">Ko</el-menu-item>
		       <el-menu-item index="10-3">mg</el-menu-item>
		      

		        </el-submenu>
			   <el-submenu index="100">
		        <template slot="title">
		           <el-avatar size="small" 
		           src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
		          {{userid}}
		        </template>
		       
		         <el-menu-item index="100-1">{{$t('newAdd.마이페이지')}}</el-menu-item>
		        <el-menu-item index="100-2">{{$t('msg.로그아웃')}}</el-menu-item>
		        </el-submenu>
			  
			</el-menu>
		  </div>
		  

		  </el-header>
		  <el-container style="height: 100%;overflow-y:auto">
		  	 <!-- 侧边布局 -->
		    <el-aside width="180px" v-if="showAside" style="position:relative;background:rgb(56, 71, 86)">
		    	  <a class="h5 text-light mb-0 text-center absolute mt240" style="width:100%;background:rgb(56, 71, 86);border-bottom:1px solid #475a6d;display:block;height:60px;line-height:60px;text-decoration:none;">{{site}}</a>
		   


       <el-menu
  style="height:100%"
  :default-active="slideMenusActive"
  @select="slideSelect"
  background-color="#384756"
  text-color="#fff"
  active-text-color="#ffd04b"
  class="mt300"
>
  <template v-for="(subitem,index) in slideMenus">
    <el-menu-item
      v-if="!subitem.children"
      :key="subitem.pathname"
      :index="subitem.pathname"
      style="height:36px;line-height:36px;"
      :class="subitem.pathname==='inoutzp_list' || subitem.pathname==='racelist_list' || subitem.pathname==='dcheck_list' || subitem.pathname==='autoqa_list' || subitem.pathname==='log_list' ? 'border-bottom-1' : ''"
    >
      <i :class="subitem.icon"></i>
      <span slot="title">{{subitem.name}}</span>
    </el-menu-item>

    <div v-else :key="subitem.pathname">
      <div style="height:36px;line-height:36px;background:#2c3844;width:100%;color:#fff;">
        <i :class="subitem.icon" style="margin-left:20px;margin-right:6px;"></i>
        {{ subitem.name }}
      </div>

      <el-menu-item
        v-for="(childs_menu,childIndex) in subitem.children"
        :key="childs_menu.pathname || childIndex"
        :index="childs_menu.pathname"
        :class="childs_menu.pathname==='betting_list7' ? 'border-bottom-1' : ''"
        style="height:36px;line-height:36px;padding-left: 20px;"
      >
        <i :class="childs_menu.icon"></i>
        {{ childs_menu.name }}
      </el-menu-item>
    </div>
  </template>
</el-menu>



		    </el-aside>
		      <el-main class="" style="position: relative;">
		    		<div style="clear:both;height: 50px;"></div>
		    			<!-- <el-breadcrumb separator="/">
						  <el-breadcrumb-item :to="{ path: '/' }">홈</el-breadcrumb-item>
						  <el-breadcrumb-item><a href="/"></a></el-breadcrumb-item>
						
						</el-breadcrumb> -->
							<div style="clear:both;height: 10px;"></div>
		    	<!-- 主内容 -->
		    	<div style="background:#fff;padding:10px;" class="mt100">
        		<router-view></router-view>
        	</div>

		    </el-main>
		  </el-container>
		</el-container>
		<!-- Model -->
		<el-dialog 
          :visible.sync="dialogModel"
          :close-on-click-modal ="false"
          width="25%">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
            
            <el-form-item  :label="$t('nav.아이디')" class="mb-0">
              <el-input v-model="form.mem_id"  class="w-75"></el-input>
            </el-form-item>
            <el-form-item  :label="$t('searchText.구분')" class="mb-0">
            	<el-select :placeholder="$t('status.선택')" v-model="gubun" class="w-75">
		              <el-option
		              v-for="item in options"
		              :key="item.value"
		              :label="item.label"
		              :value="item.value">
		            </el-option>
		            </el-select>
            </el-form-item>
            <el-form-item  :label="$t('searchText.타입')" class="mb-0">
            	<el-select :placeholder="$t('status.선택')" v-model="io_type" class="w-75">
		              <el-option
		              v-for="item in ioType"
		              :key="item.value"
		              :label="item.label"
		              :value="item.value">
		            </el-option>
		            </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.금액')" class="mb-0">
              <el-input v-model="form.money" type="number"  class="w-75"></el-input>
            </el-form-item>

             <el-form-item  :label="$t('tableText.메모')" class="mb-0">
              <el-input v-model="form.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
         
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="dialogModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" >{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
        <el-dialog 
          :visible.sync="layModel1"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('newMsg.충전신청')">
          <div>
          	<h6>{{$t('newMsg.입금계좌정보')}}</h6>
          	<div class="text-danger d-flex align-items-center" >
          		
							<template v-if="this.view == 1">{{$t('newMsg.은행')}} : {{bankname}}<span class="ml-1 mr-1">{{$t('tableText.계좌번호')}} :{{bankno}}</span>{{$t('tableText.예금주')}}  :{{banknum}}</template>

							<template v-if="this.view == 0">{{bankname}}</template>
							 <el-button id="btn-councel-bank" type="primary" size="mini" @click="submit5" v-if="this.view != 1" style="padding:5px;" class="ml-auto">{{$t('newMsg.계좌번호요청하기')}}</el-button>
						</div>

          </div>
          <div class="text-right mb-3">
					
					</div>

          <el-form ref="layform" :model="layform" label-width="100px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('newMsg.신청금액')" class="mb-0" prop="depositamount">
              <el-input v-model="layform.depositamount"   :placeholder="$t('newMsg.만원이상')"></el-input>
            </el-form-item>

             <el-form-item v-if="this.new=='1'" :label="$t('newMsg.머니구분')" class="mb-0">
             <el-radio-group v-model="layform.m_gubun" size="small">
						    
						    <template v-if="this.new_almsys!='1'">
						    <el-radio v-if="this.power=='1'" :label="1" border>{{$t('msg.파워볼')}}</el-radio>
						    <el-radio :label="3" border>{{$t('msg.알잔액')}}</el-radio>
						    <el-radio :label="2" border>{{$t('msg.카지노슬롯')}}</el-radio></template>

						    <template v-if="this.new_almsys=='1'"><el-radio :label="3" border>{{$t('msg.알잔액')}}</el-radio></template>
						 </el-radio-group>

            </el-form-item>


            <el-form-item label="" class="mb-1">
            
							<el-button money="1000000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(1000000,1)">100{{$t('newMsg.만')}}</el-button>
							<el-button money="500000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(500000,1)">50{{$t('newMsg.만')}}</el-button>
							<el-button money="100000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(100000,1)">10{{$t('newMsg.만')}}</el-button>
							<el-button money="50000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(50000,1)">5{{$t('newMsg.만')}}</el-button>
							<el-button money="10000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(10000,1)">1{{$t('newMsg.만')}}</el-button>
							<el-button money="0" type="primary" size="mini" style="margin:0;padding:8px" @click="addMoney(0,1)">{{$t('tableText.정정')}}</el-button>

            </el-form-item>
          
            <el-form-item :label="$t('newMsg.입금자명')" class="mb-0">
              <el-input v-model="layform.depositbankname" type="text" :disabled="inname"></el-input>
            </el-form-item>

           
         
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit4" :loading="layLoading" >{{$t('newMsg.신청하기')}}</el-button>
          </span>
        </el-dialog>	
         <el-dialog 
          :visible.sync="layModel2"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('newMsg.환전신청등록된계좌로출금됨')">
                  
          <el-form ref="layform1" :model="layform1" label-width="100px" v-loading="loading" :rules="rules">
            
            <template v-if="this.new!='1'">
            <el-form-item :label="$t('newMsg.환전가능금')" class="mb-0">
              <el-input v-model="layform1.availableamount" disabled></el-input>
            </el-form-item></template>

            <template v-if="this.new=='1' ">
            <el-form-item v-if="this.sim!='1'" :label="$t('msg.카슬머니')"  class="mb-0">
              <el-input v-model="layform1.availableamount1" disabled></el-input>
            </el-form-item>

             <el-form-item  :label="$t('msg.알잔액')"  class="mb-0">
              <el-input v-model="layform1.availableamount" disabled></el-input>
            </el-form-item>
            
             <el-form-item v-if="this.power=='1' && this.sim!='1'" :label="$t('msg.파워머니')" class="mb-0">
              <el-input v-model="layform1.availableamount2" disabled></el-input>
            </el-form-item>
          </template>



             <el-form-item :label="$t('newMsg.환전금액')" class="mb-0" prop="withdrawamount">
              <el-input v-model="layform1.withdrawamount" :placeholder="$t('newMsg.만단위')" autocomplete='off' :validate-event="false"></el-input>
            </el-form-item>
             <el-form-item v-if="this.new=='1'" :label="$t('newMsg.머니구분')" class="mb-0">
             <el-radio-group v-model="layform1.m_gubun" size="small">
						    
						    <template v-if="this.new_almsys!='1'">

						    <el-radio :label="3" border>{{$t('msg.알잔액')}}</el-radio>
						    <el-radio v-if="this.power=='1' && this.sim!='1'" :label="1" border>{{$t('msg.파워볼')}}</el-radio>
						    <el-radio :label="2" border>{{$t('msg.카지노슬롯')}}</el-radio></template>

						    <template v-if="this.new_almsys=='1'"><el-radio :label="3" border>{{$t('msg.알잔액')}}</el-radio></template>

						 </el-radio-group>

            </el-form-item>
            <el-form-item label="" class="mb-1">
            
							<el-button money="1000000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(1000000,2)">100{{$t('newMsg.만')}}</el-button>
							<el-button money="500000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(500000,2)">50{{$t('newMsg.만')}}</el-button>
							<el-button money="100000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(100000,2)">10{{$t('newMsg.만')}}</el-button>
							<el-button money="50000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(50000,2)">5{{$t('newMsg.만')}}</el-button>
							<el-button money="10000" type="default" size="mini" style="margin:0 2px 0 0;padding:8px 10px" @click="addMoney(10000,2)">1{{$t('newMsg.만')}}</el-button>
							<el-button money="0" type="primary" size="mini" style="margin:0;padding:8px" @click="addMoney(0,2)">{{$t('tableText.정정')}}</el-button>

            </el-form-item>
          
            <el-form-item :label="$t('newMsg.이체비밀번호')" class="mb-0">
              <el-input v-model="layform1.withdrawfundpw" type="password" autocomplete='new-password'></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit3" :loading="layLoading" >{{$t('newMsg.신청하기')}}</el-button>
          </span>
        </el-dialog>	
        
        <el-dialog 
          :visible.sync="layModel3"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('newMsg.롤링머니로전환')">
           
           <template v-if="this.new=='1'">
          
          <el-form ref="layform2" :model="layform2" label-width="100px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('msg.카슬롤링')" v-if="this.sim!='1'" class="mb-0">
              <el-input v-model="mem_eventmoney" disabled></el-input>
            </el-form-item>

            <el-form-item :label="$t('msg.롤링머니')" v-if="this.sim=='1'" class="mb-0">
              <el-input v-model="mem_eventmoney" disabled></el-input>
            </el-form-item>

             <el-form-item :label="$t('newMsg.전환금액')" class="mb-0" prop="rollingamount1">
              <el-input v-model="layform2.rollingamount1" placeholder=""></el-input>
            </el-form-item>
          </el-form>

          <div class="d-flex mb-1" style="justify-content:center;align-items:center;padding-bottom: 10px; border-bottom: 3px solid #ddd;">
          	<span class="text-primary mr-4" @click="submitGo()" style="cursor:pointer">{{$t('newMsg.롤링금내역')}}</span>
            <el-button type="primary" :loading="layLoading" @click="submit2(1)">{{$t('msg.전환하기')}}</el-button>
          </div>

          <template v-if="this.power=='1' && this.sim!='1'">
          	<div style="background:#f9f9f9;padding: 10px;">
          <el-form ref="layform2" :model="layform2" label-width="100px" v-loading="loading" :rules="rules">
            <el-form-item :label="$t('msg.파워롤링')" class="mb-0 mt-2">
              <el-input v-model="power_ecash" disabled></el-input>
            </el-form-item>
             <el-form-item :label="$t('newMsg.전환금액')" class="mb-0" prop="rollingamount2">
              <el-input v-model="layform2.rollingamount2" placeholder=""></el-input>
            </el-form-item>
          </el-form>
           <div class="d-flex" style="justify-content:center;align-items:center;padding-bottom: 10px; ">
          	<span class="text-primary mr-4" @click="submitGo()" style="cursor:pointer">{{$t('newMsg.롤링금내역')}}</span>
            <el-button type="primary" :loading="layLoading" @click="submit2(2)">{{$t('msg.전환하기')}}</el-button>
          </div>
        </div></template>
           <template v-if="this.rosing=='1'">
        
          <el-form ref="layform2" :model="layform2" label-width="100px" v-loading="loading" :rules="rules">
            <el-form-item :label="$t('msg.루징')" class="mb-0 mt-2">
              <el-input v-model="mem_emoney" disabled></el-input>
            </el-form-item>
             <el-form-item :label="$t('newMsg.전환금액')" class="mb-0" prop="rollingamount3">
              <el-input v-model="layform2.rollingamount3" placeholder=""></el-input>
            </el-form-item>
          </el-form>

           <div class="d-flex " style="justify-content:center;align-items:center">
          	<span class="text-primary mr-4"  style="cursor:pointer">{{$t('newMsg.루징금내역')}}</span>
            <el-button type="primary" :loading="layLoading" @click="submit6()">{{$t('msg.전환하기')}}</el-button>
          </div></template>

          </template> 

          <template v-if="this.new!='1'">
          <el-form ref="layform2" :model="layform2" label-width="100px" v-loading="loading" :rules="rules">
            <el-form-item :label="$t('newMsg.롤링')" class="mb-0">
              <el-input v-model="mem_eventmoney" disabled></el-input>
            </el-form-item>
             <el-form-item :label="$t('newMsg.전환금액')" class="mb-0" prop="rollingamount">
              <el-input v-model="layform2.rollingamount" placeholder=""></el-input>
            </el-form-item>
          </el-form>
          <div class="d-flex mb-1" style="justify-content:center;align-items:center">
          	<span class="text-primary mr-4" @click="submitGo()" style="cursor:pointer">{{$t('newMsg.롤링금내역')}}</span>
            <el-button type="primary" :loading="layLoading" @click="submit22()">{{$t('newMsg.머니로전환')}}</el-button>
          </div>


          
          </template> 



        </el-dialog>	
         <el-dialog 
          :visible.sync="exchangeGmApim"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('msg.전환하기')">

          <el-form  label-width="100px" v-loading="loading" >
            <el-form-item :label="$t('msg.파워머니')" class="mb-0">
              <el-input v-model="power_cash" class="w-50 mr-1"></el-input>
              <el-button type="primary" @click="exchaneSubmit('power')">{{$t('newMsg.카슬머니로전환')}}</el-button>
            </el-form-item>
             <el-form-item :label="$t('msg.카슬머니')" class="mb-0" >
              <el-input v-model="api_money" placeholder=""  class="w-50 mr-1"></el-input>
              <el-button type="default" @click="exchaneSubmit('api')">{{$t('newMsg.파워머니로전환')}}</el-button>
            </el-form-item>
          </el-form>
        


        </el-dialog>
         <el-dialog 
          :visible.sync="exchangeGmApim1"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('msg.전환하기')">

          <el-form  label-width="80px" v-loading="loading" >
            <el-form-item :label="$t('nav.알잔액')" class="mb-0">
              <el-input v-model="mem_cash" class="w-50 mr-1"></el-input>
              <el-button type="default" @click="exchaneSubmit1('api')" :loading="exchangeGmApimLoad">{{$t('newMsg.카슬머니로전환')}}</el-button>
            </el-form-item>
             <el-form-item :label="$t('msg.카슬머니')" class="mb-0" >
              <el-input v-model="api_money" placeholder=""  class="w-50 mr-1"></el-input>
              <el-button type="primary" @click="exchaneSubmit1('mem_cash')" :loading="exchangeGmApimLoad">{{$t('newMsg.알잔액으로전환')}}</el-button>
            </el-form-item>
             <el-form-item  class="mb-0" >
            <span style="line-height:20px;color:rgb(200, 64, 13);display:inline-block"> 게임을 하실경우 "카슬머니"로 전환<br>
하부로 "알충" 하실 경우 다시 "알잔액"으로 전환</span>
            </el-form-item>
          </el-form>

        


        </el-dialog>
     
        <div class="bottom_msg d-flex" v-if="this.bottom_msg !=''">
        	<div class="">
   					 <span>{{bottom_msg}}</span>
					</div>
						  
		    		<el-button type="danger" @click="msgClose" class="ml-auto">CLOSE</el-button>
					
			 </div>
         
	</div>

 </template>

 <script>
 import  common from "../components/mixins/common.js"
import EventBus from '../assets/js/eventBus.js';
 import shopDialog from '../components/common/shop-dialog.vue';

    export default {
    	components: {
     
      shopDialog,
      
    },
    	mixins:[common],
    	data(){
    		return{
    			showAside:true,
    				openeds:['memlist_list','calcuser_list','betting_list1','qa_list'],
    			exchangeGmApimLoad:false,
    			lang:'ko',
    			layLoading:false,
    			disabled:false,
    			inname:true,
    			domain:window.sessionStorage.getItem('domain'),
    		
    			admin_id:window.sessionStorage.getItem('admin_id'),
    			   site:window.sessionStorage.getItem('site'),
                sitetype:window.sessionStorage.getItem('sitetype'),
                ulevel:window.sessionStorage.getItem('level'),
                simp:window.sessionStorage.getItem('simp'),
                 userid:window.sessionStorage.getItem('userid'),
	power:window.sessionStorage.getItem('power'),
	rosing:window.sessionStorage.getItem('rosing'),
		new:window.sessionStorage.getItem('new'),
		new_almsys:window.sessionStorage.getItem('new_almsys'),
		sim:window.sessionStorage.getItem('sim'),
			screenWidth: window.innerWidth,
    			memopush:false,
    			qapush:false,
    			change_btn:false,
    			view:'',
    			bankname:'',
    			banknum:'',
    			bankno:'',
    			bottom_msg:'',
    			pWidth:'400px',
    			passDialog:false,
    			 layoutWidth:'500px',
    			rules: {
                  depositamount:[{ required: true, message: '', trigger: 'submit'}],
                  //rollingamount:[{ required: true, message: '', trigger: 'blur'}],
                  withdrawamount:[{ required: true, message: '', trigger: 'submit'}],
                  addsubject:[{ required: true, message: '', trigger: 'blur'}],
                  addcontent:[{ required: true, message: '', trigger: 'blur'}],
                },
    			isShow:true,
    			exchangeGmApim:false,
    			exchangeGmApim1:false,
    			power_money:'0',

    			casino_money:'0',
    			layform1:{
    				availableamount:'0',
    				availableamount1:'0',
    				availableamount2:'0',
    				withdrawamount:'',
    				withdrawfundpw:'',
    				m_gubun:3

    			},
    			layform2:{
            rollingamount:'',
    				rollingamount1:'',
    				rollingamount2:'',
    				rollingamount3:''
    			},
    			layform3:{
    				addsubject:'',
    				addcontent:''
    			},
    			
    			layform:{
    				depositamount:'',
    				depositbankname:'',
    				m_gubun:3

    			},
    			layModel1:false,
    			layModel2:false,
    			layModel3:false,
    			layModel4:false,
    			menu_name:{
                 'memlist_list':this.$i18n.t("nav.회원관리"),
                 'user_list':this.$i18n.t("nav.회원관리"),
                 'bubon_list':this.$i18n.t("nav.부본사관리"),
                 'zp_list':this.$i18n.t("nav.총판관리"),
                 'inout_list':this.$i18n.t("nav.회원별입출금"),
                  'inoutzp_list':this.$i18n.t("nav.총판별입출금"),
                'race_list':this.$i18n.t("nav.RACE결과"),
                'buy_list':this.$i18n.t("nav.구매내역RACE"),
                 'racelist_list':this.$i18n.t("nav.RACE리스트"),
                 'money_list':this.$i18n.t("nav.입출금내역"),                
                  'moneybak_list':this.$i18n.t("nav.알충환내역"),
                 'lossrace_list':this.$i18n.t("nav.손실금RACE"),
                 
                 'moneylogs_list':this.$i18n.t("nav.머니로그"),
                  'calculation_list':this.$i18n.t("nav.정산관리"),
                   'calculation_new_list':this.$i18n.t("nav.정산관리"),
                 'dcheck_list':this.$i18n.t("nav.출석체크"),
                 'qa_list':this.$i18n.t("nav.고객센터"),
                'memo_list':this.$i18n.t("nav.쪽지관리"),
                 'board_list':this.$i18n.t("nav.게시판"),
                 'pop_list':this.$i18n.t("nav.팝업관리"),
                  'autoqa_list':this.$i18n.t("nav.답변관리"),
                 'online_list':this.$i18n.t("nav.접속리스트"),
                 'acclist_list':this.$i18n.t("nav.접속로그"),
                 'betting_list1':this.$i18n.t("nav.배팅내역"),
                 'betting_list2':this.$i18n.t("nav.배팅내역"),
                 'betting_list3':this.$i18n.t("nav.배팅내역"),
                 'betting_list4':this.$i18n.t("nav.배팅내역"),
                 'betting_list5':this.$i18n.t("nav.배팅내역"),
                 'betting_list6':this.$i18n.t("nav.배팅내역"),
                 'betting_list7':this.$i18n.t("nav.배팅내역"),
                 'log_list':this.$i18n.t("nav.종합로그"),
                 'settings_list':this.$i18n.t("nav.사이트설정"),
                 'order_list':this.$i18n.t("nav.구매내역파워볼"),
                
                 
                 'sp_list':this.$i18n.t("nav.매장관리"),
                  'powerball_list':this.$i18n.t("nav.파워볼결과"),
                 'sadari_list':this.$i18n.t("nav.사다리결과"),
                 'powerball_bg_list':this.$i18n.t("nav.파워볼결과보글"),
                 'sadari_bg_list':this.$i18n.t("nav.사다리결과보글"),
                 'api_list':this.$i18n.t("nav.배팅내역"),
                  'losinglist_list':this.$i18n.t("nav.루징정산"),
                  'alert_list':this.$i18n.t("nav.팝업관리"),
                  'rdp_list':this.$i18n.t("nav.일자별롤링루징"),
                
                  'dashboard_index':this.$i18n.t("nav.대시보드"),
                   
             
                        'bubon2_list':this.$i18n.t("newAdd.부부본사관리"),
                        
                          'bon_list':this.$i18n.t("nav.본사관리"),
                         
                          'proce_list':this.$i18n.t("nav.루징정산"),
                           'income_index':this.$i18n.t("newAdd.일자별현황"),
                            'coupon_list':this.$i18n.t("newAdd.쿠폰관리"),
                            'jang_list':this.$i18n.t("searchText.죽장정산"),
                              'rolling_c_list':this.$i18n.t("msg.롤링전환"),
                                'calcuser_list':this.$i18n.t("msg.단계별정산"),
                                'moneylogs_user_list':this.$i18n.t("nav.머니로그"),
                                  'layModel1':this.$i18n.t("newMsg.충전신청"),
                                    'layModel2':this.$i18n.t("newMsg.환전신청"),


                },
    			domain:window.sessionStorage.getItem('domain'),
    			form:{
    				mem_id:'',
    				money:'',
    				memo:'',
    			},
    			newlist:[],
    			newlist2:[],	
    			dsq:null,

    			gubun:'',
    			io_type:'',
    			loading:false,
    			dialogModel:false,
    			mem_cash:'',
    			mem_eventmoney:'',
    			mem_emoney:'',
    				power_cash:'',
    				api_money:'',
    			power_ecash:'',
    			habu_event:'',
    			habu_apimoney:'',

            pt_event:'',
          pt_apimoney:'',


    			rogdd:'',
    			event_loing_recom_e:'',
    			event_loing_recom_slot:'',
    			event_loing_recom:'',
    			event_loing_group_recom:'',
    		pc_slot:'',
    			pc_e:'',
    		
               
        		navBars:[],
        		options: [{
	             
	              label: '게임머니',
	               value: '1',
	             
	            }, {
	              label: '이벤트머니',
	               value: '2',
	             
	            }],
	            ioType: [
	             {
	              label: '충전',
	               value: '1',
	             
	            }, {
	              label: '환전',
	               value: '2',
	             
	            }],
        	}
    	},
    	mounted(){
    		

    	},
    	created(){
if(this.screenWidth <990){
    			this.showAside = false
    		}
    		
    			document.title=this.site+"-파트너";

    		let token=window.sessionStorage.getItem('user');
    		if(token==null)
    		{
               this.$router.push({name:'login'})
               return;
    		}



    		if(this.new_almsys=='1')
    		{
            this.layform1.m_gubun=3;
            this.layform.m_gubun=3;
    		}

    		

    		if(this.sitetype=="3")
    		{
                this.options=[{
	             
	              label:  this.$i18n.t("msg.게임머니"),
	               value: '1',
	             
	            }, {
	              label:  this.$i18n.t("msg.이벤트머니"),
	               value: '2',
	             
	            }, {
	              label:  this.$i18n.t("msg.롤링머니"),
	               value: '3',
	             
	            }];
    		}
    		this.getbalance();
    		this.getStatus();

    		this.navBars = this.$conf.navBars
    		let language=window.sessionStorage.getItem('lang');
    		if(language)
    		{
           this.lang=language
    		}

    		if(this.lang=='en'){
    			this.navBars = this.$confEn.navBars
    		}
        else if(this.lang=='mg')
        {
           this.navBars = this.$confMg.navBars
        }
    		else{
    			this.navBars = this.$conf.navBars
    		}

    		this.$i18n.locale = this.lang;
    		// 初始化选中菜单
			this.__initNavBar()
			
			let that=this

				const timer = window.setInterval(()=>{
	           this.getStatus()
            }, 20000)
            
            this.$once('hook:beforeDestroy', function () {
               window.clearInterval(timer)
            })

            let menulist = this.navBars.list[0].submenu;

            menulist.forEach(item=>{
            
                that.newlist2=[];

                let children=item.children;
                children.forEach(item2=>{
                	 if(item2.pathname=="calculation_new_list")
                	 {
                	 	  if(that.simp=="1")
                	 	  {
                         that.newlist2.push(item2);
                	 	  }
                      
                	 }else
                	 {
                	 	  that.newlist2.push(item2);
                	 }
                	 
                });

                item.children=that.newlist2;
                that.newlist.push(item);

                
           });

           



    	},
    	watch: {
			/*'$route'(to, from) {
				// 本地存储
				localStorage.setItem('navActive',JSON.stringify({
					top:this.navBars.active || '0',
					left:this.slideMenusActive || '0'
				}))
				
			}*/
		},
    	computed:{


    		/*slideMenusActive:{
    			get(){

    				return this.navBars.list[this.navBars.active].subActive || '0'
    			},
    			set(val){
    				return this.navBars.list[this.navBars.active].subActive = val


    			},
    			
    		},*/
    		slideMenus(){
    			return this.newlist

    		},

    	},
    	methods: {
    		getbalance(){

    			let token=window.sessionStorage.getItem('user');
    			this.$axios({
                      method:'post',
                      
                      url:this.domain+'/user/ptbalance',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                  	
                    
                    if(response.data.code==200){
                      

                      this.power_cash=response.data.power_cash
                      this.api_money=response.data.api_money
                      this.mem_cash=response.data.mem_cash
                      this.mem_emoney=response.data.mem_emoney
                       this.habu_apimoney=response.data.habu_apimoney
                        this.habu_event=response.data.habu_event

                           this.pt_apimoney=response.data.pt_apimoney
                      this.pt_event=response.data.pt_event

                           this.rogdd=response.data.rogdd
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                 
    
                  }).catch((error) =>{
                      
                  })
    		},
    		exchaneSubmit(v){
    			let token=window.sessionStorage.getItem('user');
    			let money=0;
    			if(v=='power')
    			{
            money=this.power_cash
    			}else
    			{
            money=this.api_money
    			}

    			if(this.change_btn)
    			{
    				return;
    			}

    			this.change_btn=true;
          this.$axios({
                      method:'post',
                      
                      url:this.domain+'/user/exchange_power_api?type='+v+'&cash='+money,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                  	this.change_btn=false;
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      this.power_cash=response.data.power_cash
                      this.api_money=response.data.api_money
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      this.change_btn=false;
                  })
                  
    		},
   showNav(){
			      	this.showAside = !this.showAside

			      },
    		exchaneSubmit1(v){
    			let token=window.sessionStorage.getItem('user');
    			let money=0;
    			if(v=='mem_cash')
    			{
            money=this.api_money
    			}else
    			{
    				 money=this.mem_cash
           
    			}

    			if(this.change_btn)
    			{
    				return;
    			}

    			this.exchangeGmApimLoad=true;

    			this.change_btn=true;
          this.$axios({
                      method:'post',
                      
                      url:this.domain+'/user/exchange_gm_apim?type='+v+'&cash='+money,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                  	this.change_btn=false;
                  	this.exchangeGmApimLoad=false;
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      this.mem_cash=response.data.mem_cash
                      this.api_money=response.data.api_money
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      this.change_btn=false;
                  })
                  
    		},

    		toExange(){
    			this.exchangeGmApim = true

    			 let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/money_info'
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                   
                   
                    this.power_cash = response.data.data.power_cash
                    this.api_money = response.data.data.api_money
                  
                    
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
               
               
            })

    		},
    		msgClose(){
    			this.bottom_msg = ''
    		},
    		toExangeApiCash(){

    			if(this.new_almsys!="1")
    			{
             return;
    			}
    			this.exchangeGmApim1 = true

    			 let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/money_info'
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                   
                   
                    this.mem_cash = response.data.data.mem_cash
                    this.api_money = response.data.data.api_money
                  
                    
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
               
               
            })

    		},
    		openAgentModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1200px', '550px'],
           
        });
        
        },
    		 
    		layClick1(){
    			this.layModel1 = true
    				let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/add_money_info'
          this.layform.depositamount=''
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                      //console.log('add_money_info=',response.data.data)
                      this.bankname = response.data.data.bankname
											this.banknum = response.data.data.banknum
											this.bankno = response.data.data.bankno
											this.view = response.data.data.view
											this.inname=response.data.data.read

											this.layform.m_gubun=response.data.data.m_gubun

											this.layform.depositbankname= response.data.data.mem_bankname
                   
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		layClick2(){
    			this.layModel2 = true
    			let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/out_money_info'
           this.layform1.withdrawamount=''
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    // console.log('mem_cash=',response.data.data.mem_cash)
            	      this.layform1.m_gubun=response.data.data.m_gubun
                    this.layform1.availableamount = this.formatMoney(response.data.data.mem_cash)
                    this.layform1.availableamount1 = this.formatMoney(response.data.data.api_money)
                    this.layform1.availableamount2 = this.formatMoney(response.data.data.power_cash)
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		layClick3(){

    			if(this.sitetype=='2')
    			{
return;
    			}
    			this.layModel3 = true

    			let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/money_info'
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                     //console.log('response',response.data.data.power_ecash)
                   
                    this.power_ecash = this.formatMoney(response.data.data.power_ecash)
                    this.mem_eventmoney = this.formatMoney(response.data.data.mem_eventmoney)
                    this.mem_emoney = this.formatMoney(response.data.data.mem_emoney)
                    
               
            }).catch((error) =>{
              

               this.$message.error(error);
               
               
               
            })

    		},
    		layClick4Go(){
    			this.$router.push({
		  		name:'qa_list'
		  	})
 this.slideMenusActive='qa_list'
		  		localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'qa_list'
                    }))
		  			this.$router.replace('/refresh')
    		
    		},
    		submitGo(){
    			this.layModel3 = false
    			
    				this.$router.push({
	      					 path: `/moneylogs_user/list?activeName=two`,
            })
	      	
	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'moneylogs_user_list'
                    }))
	     
	     

	      	 this.$router.replace({ path: '/refresh', query: { activeName:'two' }})

    			

	      
	    


    		},
    		getStatus(){
    			let token=window.sessionStorage.getItem('user'); 
    			//console.log('token',token)


    			if(token)
    			{
                  this.$axios({
                  method:'post',
                  url:this.domain+'/user/process',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
		    
		            }).then((response) =>{ 

		            	if(response.data.code==401)
		                	{
		                		  window.sessionStorage.clear();
                          this.$router.push({name:'login'})
		                	}

     		          if(response.data.data.memocount >0 ){

     		          	let answer = confirm(this.$i18n.t("newMsg.쪽지가도착확인해주세요"));
     		          	if(answer)
     		          	{
     		          			this.$router.push({
										  		name:'memo_list'
										  	})
						               this.slideMenusActive='memo_list'
								  		      localStorage.setItem('navActive',JSON.stringify({
						                      top:'0',
						                      left:'memo_list'
						                    }))
     		          	}

     		          	
     		          
     		         //  	this.$confirm('쪽지가도착 확인해 주세요', '알림', {
								        //   confirmButtonText: '확인',
								        //   cancelButtonText: '취소',
								        //   type: 'warning'
								        // }).then(() => {
								        // 	 this.$router.push({name:'memo_list'})
								        // })
     		          }
     		           if(response.data.data.qacc >0 ){

     		           	let answer = confirm('문의답변도착 확인해 주세요');
     		          	if(answer)
     		          	{
     		          			this.$router.push({
										  		name:'qa_list'
										  	})
						               this.slideMenusActive='qa_list'
								  		      localStorage.setItem('navActive',JSON.stringify({
						                      top:'0',
						                      left:'qa_list'
						                    }))
     		          	}

     		         //  this.$messageSingle.info('문의답변도착 확인해 주세요');

     		         //  	this.$confirm('문의답변도착 확인해 주세요', '알림', {
								        //   confirmButtonText: '확인',
								        //   cancelButtonText: '취소',
								        //   type: 'warning'
								        // }).then(() => {
								        // 	 this.$router.push({name:'qa_list'})
								        // })
     		          }
     		          // let data = response.data.data

     		          	this.api_money=response.data.data.api_money
				
									this.mem_cash=response.data.data.mem_cash
									this.mem_eventmoney = response.data.data.mem_eventmoney
									this.power_cash=response.data.data.power_cash
									this.power_ecash = response.data.data.power_ecash
									this.event_loing_recom_slot = response.data.data.event_loing_recom_slot
									this.event_loing_recom_e = response.data.data.event_loing_recom_e

									this.event_loing_recom = response.data.data.event_loing_recom
									this.event_loing_group_recom = response.data.data.event_loing_group_recom


									this.pc_slot = response.data.data.pc_slot
									this.pc_e = response.data.data.pc_e
									this.bottom_msg = response.data.data.bottom_msg
									
								

	                 EventBus.$on('mem_cash',data => {
							    	this.mem_cash = data*1
							    	})

	                 EventBus.$on('habu_apimoney',data => {
							    	this.habu_apimoney = data*1
							    	})
									
	

		               
		                }).catch((error) =>{  

		                	if(error.response.status==401)
		                	{
		                		  window.sessionStorage.clear();
                          this.$router.push({name:'login'})
		                	}

		                 
		               })
		    	}
                

    		},
    	
    		submit22(){
    				
    			 let token=window.sessionStorage.getItem('user');
    			 
    			 

    			 

    			
              if(this.layform2.rollingamount<1000)
	           {
	            //this.$message.error( this.$i18n.t("newMsg.최소전환금액천원입니다"))
	             //  return;
	           }

	           if(this.layform2.rollingamount %1000!=0)
	           {
	            //this.$message.error( this.$i18n.t("newMsg.천원단위로환전해주세요"))
	            //  return;
	           }
    			 

           
          
            this.$refs.layform2.validate((e)=>{
             if(!e) return;
              this.loading = true
             this.$axios({
                    method:'post',
                    url:this.domain+'/user/exchange_gm_ev',
                    data:this.layform2,
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      

                   
                       this.layModel3 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                       this.mem_cash=response.data.mem_cash
                       this.mem_eventmoney=response.data.mem_eventmoney
                       this.api_money=response.data.api_money

                       



                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })

           })
              
    		},
    			submit2(v){
    				
    			 let token=window.sessionStorage.getItem('user');
    			 let t1=this.layform2.rollingamount1;
    			 let t2=this.layform2.rollingamount2;


    			 if(v=='1')
    			 {
              if(this.layform2.rollingamount1<1000)
	           {
	            //this.$message.error(this.$i18n.t("newMsg.최소전환금액천원입니다"))
	             //  return;
	           }

	           if(this.layform2.rollingamount1 %1000!=0)
	           {
	           // this.$message.error(this.$i18n.t("newMsg.천원단위로환전해주세요"))
	            //  return;
	           }
    			 }

    			 if(v=='2')
    			 {
              if(this.layform2.rollingamount2<1000)
	           {
	            //this.$message.error(this.$i18n.t("newMsg.최소전환금액천원입니다"))
	             //  return;
	           }

	           if(this.layform2.rollingamount2 %1000!=0)
	           {
	            // this.$message.error(this.$i18n.t("newMsg.천원단위로환전해주세요"))
	             // return;
	           }
    			 }

    			 this.layLoading = true

           
          
            this.$refs.layform2.validate((e)=>{
             if(!e) return;
              this.loading = true
             this.$axios({
                    method:'post',
                    url:this.domain+'/user/exchange_gm_ev',
                    data:this.layform2,
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                this.layLoading = false
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      

                   
                       this.layModel3 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                       this.mem_cash=response.data.mem_cash
                       this.mem_eventmoney=response.data.mem_eventmoney

                       this.api_money=response.data.api_money

                       this.power_cash=response.data.power_cash
                       this.power_ecash=response.data.power_ecash



                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })

           })
              
    		},
    		submit6(){
    				
    			 let token=window.sessionStorage.getItem('user');
    			
    			 this.layLoading = true

            this.$refs.layform2.validate((e)=>{
             if(!e) return;
              this.loading = true
             this.$axios({
                    method:'post',
                    url:this.domain+'/user/exchange_ro_gm',
                    data:this.layform2,
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                this.layLoading = false
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      

                   
                       this.layModel3 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                       this.mem_cash=response.data.mem_cash
                       this.mem_eventmoney=response.data.mem_eventmoney
                        this.mem_emoney=response.data.mem_emoney
                       this.api_money=response.data.api_money
                       this.power_cash=response.data.power_cash
                       this.power_ecash=response.data.power_ecash



                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })

           })
              
    		},
    		submit3(){
    			this.layLoading = true
    			//this.disabled = true
    			 let token=window.sessionStorage.getItem('user');
    			  this.$refs.layform1.validate((e)=>{
             if(!e) return;
               this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/pdeposit_send',
                    data:
                    {
                    	s_amount:this.layform1.withdrawamount,
                    	mem_jumin:this.layform1.withdrawfundpw ,
                    	s_gubun:2,
                    	m_gubun:this.layform1.m_gubun
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                    this.layLoading = false
    										this.loading = false
                
                  
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      
                    	 
                   
                       this.layModel2 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                      
								     this.mem_cash=response.data.mem_cash
								      this.power_cash=response.data.power_cash
								       this.api_money=response.data.api_money

								       this.availableamount1=response.data.api_money
								       this.availableamount2=response.data.power_cash
								     


                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
           })
         
    		},
    			submit4(){
    			
    			 let token=window.sessionStorage.getItem('user');
           //this.disabled = true
           this.$refs.layform.validate((e)=>{
             if(!e) return;
             this.layLoading = true

             this.$axios({
                    method:'post',
                    url:this.domain+'/user/pdeposit_send',
                    data:{
                    	s_amount:this.layform.depositamount,
                    	bank_user:this.layform.depositbankname ,
                    	s_gubun:1,
                    	m_gubun:this.layform.m_gubun
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                      this.layLoading = false
           					//	this.disabled = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      
                    	
                      
                       this.layModel1 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   

                      this.mem_cash=response.data.mem_cash
								      this.power_cash=response.data.power_cash
								       this.api_money=response.data.api_money

								       this.availableamount1=response.data.api_money
								       this.availableamount2=response.data.power_cash

                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{

              	 this.layLoading = false
              	 this.loading = false

                  //console.log(error)       //请求失败返回的数据
              })

           })
              
    		},
    		submit5(){
    				
    			 let token=window.sessionStorage.getItem('user');
        

           this.isShow = false

              this.$axios({
                    method:'post',
                    url:this.domain+'/user/inquiries_add',
                    data:{
                    	title: this.$i18n.t("newMsg.계좌문의"),
											contents: this.$i18n.t("newMsg.계좌문의")
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

              	 this.isShow = true
                   
                
                    
                    let item = response.data.data
                
                    if(response.data.code==200){
                      

                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                        this.$router.push({
                   path: `/qa/list?activeName=second`,
            })

                     localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'qa_list'
                    }))

	      	           this.$router.replace('/refresh')
		  		

                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
          // })
             
    		},
    		addMoney(value,type){

    	
    			  let money = 0;
    			  if(type=1){
    			  	let tmp_money = this.layform.depositamount;
    			  	  if( tmp_money != "" ) money = tmp_money;
							  this.layform.depositamount = money + value;
							  if( value == 0) this.layform.depositamount = "";

    			  }
    			  if(type =2){
    			  	let tmp_money = this.layform1.withdrawamount;
    			  	 if( tmp_money != "" ) money = tmp_money;
							  this.layform1.withdrawamount = money + value;
							  if( value == 0) this.layform1.withdrawamount = "";

    			  }
					  
					 

    		},
    		 play(v) {
    		 	//在这给音频 赋值 地址
			    //  this.$refs.audio.src("test.mp3");
			      //this.$refs.audio.play();

			      console.log('vvv',v);

			      var ttsAudio = document.getElementById('ttsAudio');
                  ttsAudio.src="../static/audio/"+v;
			      ttsAudio.play();
			    },
    	
    	
    	  __initNavBar(){
    	  
			let r = localStorage.getItem('navActive')  
			//console.log(r)
			
			if (r) {
				r = JSON.parse(r)
				this.navBars.active = r.top
				this.slideMenusActive = r.left
			}
		  },	

	      handleSelect(key, keyPath) {
	       // console.log(key);
	        this.navBars.active = key
	        if(key === '10-1'){
	        	
	        	this.$confirm('Are you sure to switch languages?', 'Tip', {
							       confirmButtonText: 'OK',
							       cancelButtonText: 'Cancel',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'ko' ||  this.lang === 'mg') {
							          this.lang = 'en';
							          this.$i18n.locale = this.lang;

							          window.sessionStorage.setItem('lang','en')
							          this.$router.replace('/refresh')

							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							           message:'Cancel'
							       });          
							    });
	        }
	        if(key === '10-2'){
	        	this.$confirm('언어를 전환하시겠습니까?', '알림', {
							       confirmButtonText: '확인',
							       cancelButtonText: '취소',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'en' ||  this.lang === 'mg') {
							          this.lang = 'ko';
							          this.$i18n.locale = this.lang;
							          window.sessionStorage.setItem('lang','ko')
							          this.$router.replace('/refresh')
							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							            message:'취소'
							       });          
							    });
	        }
	         if(key === '10-3'){
	        	this.$confirm('Та хэлээ солимоор байна уу?', 'мэдэгдэл', {
							       confirmButtonText: 'Баталгаажуулах',
							       cancelButtonText: 'Cancel',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'en' ||  this.lang === 'ko') {
							          this.lang = 'mg';
							          this.$i18n.locale = 'mg';
							          window.sessionStorage.setItem('lang','mg')
							          this.$router.replace('/refresh')
							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							            message:'цуцлах'
							       });          
							    });
	        }
	       
	        if(key === '100-2'){
	        	window.sessionStorage.clear();

	        
	        	//window.localStorage.clear();
                localStorage.setItem('navActive',JSON.stringify({
					top:'0',
					left:'memlist_list'
				})) 
          
			
			
	        	this.$router.push({name:'login'})
	        }
	        if(key ==='100-1'){
	        	this.$router.push({name:'mypage_index'})
	        }

	        /*this.slideMenusActive = '0'
			if (this.slideMenus.length>0) {
				this.$router.push({
					name:this.slideMenus[this.slideMenusActive].pathname
				})
			}*/
	      },
	     
	       slideSelect(key,indexPath){

	      

	       	//return;
	       	if(key==='layModel1'){
	       		this.layClick1()
	       		return;
	       	}else if(key==='layModel2'){
	       		this.layClick2()
	       		return;
	       	}
	      	this.$router.push({
	      		name:key,
	      		query: {
                 t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
                }
	      	})

	      	 //console.log('gaga',key);
	      	

		      if(this.slideMenusActive==key)
		      {
	             //同一个菜单点击
		      	  this.$router.replace({
		          path: '/redirect',
		          query: {
		            path: key
		          }
		        })
		      }
		       this.slideMenusActive = key
			     localStorage.setItem('navActive',JSON.stringify({
							top:'0',
							left:key
						}))
	      },
	        toLink(){
		  	this.$router.push({
		  		name:'moneylogs_list'
		  	})
 this.slideMenusActive='moneylogs_list'
		  		localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'moneylogs_list'
                    }))
		  		
		  },
 toCal(){
 	
		  	this.$router.push({
		  		name:'calculation_list'
		  	})
 this.slideMenusActive='calculation_list'
		  		localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'calculation_list'
                    }))
		  			this.$router.replace('/refresh')

		  },
	     
    }
  }
</script>


 <style scoped>
 	.nav-item{
 		min-width: 80px;
    border: 1px solid #9e9e9e;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 8px!important;
    text-align: center;
    position: relative;

 	}
 	.nav-item a{
 		font-size: 12px;
    color: #666;
    font-weight: 700;
 	}
 	.nav-item span{
 		display: block;
 		text-shadow: 1px 1px 1px #404040;
 		font-size: 14px;
 		color: #fff;
 	}
 	.nav-item span.badge{
 		border-radius: 0;
 	}
 	.nav-item span.badge-default {
    background-color: #b0bec5;
}
 >>>.el-menu{
 	border-right:none;
 }
 	.close{
 		background: rgba(0, 0, 0, .8);
 		width: 30px;
 		height: 30px;
 		line-height: 30px;
 		border-radius: 100%;
 		text-align: center;
 	}
 	.close i{
 		color: #fff;
 		font-size: 16px;
 	}
 	
.bg-default{
	background-color: #f3f3f3;
}
>>> .rdp .el-dialog__body{
	padding-bottom: 0;
}
>>> .el-header{
	padding: 0;
}
 >>>.el-menu--horizontal>.el-submenu .el-submenu__title,>>>.el-menu.el-menu--horizontal{
        	border-bottom: none;
        }
   @media (min-width: 1570px){
        .myTable .table{
        	width: 65%;

        }
     
    }
     @media (max-width:1200px){
       .d-1250{
        flex-direction: column;
       }
       .mt-1250{margin-top: 5px}
       .textArea {width: 200px}
       .ml-1250{margin-left: 205px}
     
    }
    @media screen and (max-width:1000px){
       .d-800{
       	display:none !important;

       }
     
    }
    .scroll-div table{
    min-width:1440px
    }
     .scroll-div table tr td,.scroll-div table tr th{
    	white-space:nowrap;
    } 
    >>>.el-button.is-circle{
    	padding: 3px;
    background: transparent;
    border: none;
    color: #fff;font-size: 16px !important;
    }
    .bottom_msg{
    align-items: center;
    bottom: 10%;
    width: 60%;
    padding: 10px;
    background:rgba(0, 0, 0, .8);
    border-radius: 5px;
 
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #fff;
    width: 60%;
    position: fixed;
    z-index: 9997;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0 auto;
 }
 >>>.el-breadcrumb{
 	background:#000;height:35px;line-height:35px;margin-top:10px;
 }
 >>>.el-breadcrumb__inner a, >>>.el-breadcrumb__inner.is-link{
color:#fff;padding-left:10px
 }
 .left20{left:20px}
 .left200{left:180px}
>>>.el-submenu .el-submenu__title div{background:#000 !important;color:#ff0 !important}
>>>.el-dialog__body{
 padding-top:0;padding-bottom:0
}
@media (min-width: 990px) {
.wbig{
	width:calc(100% - 180px)
}
.display{display:none}

.ml-59-0{margin-left:59px}
}
@media (max-width: 990px) {
.wbig{
	width:100%
}
.absolute{position:absolute;}
.topr{right:0;top:0}
.t-60{margin-top:65px;}
.ml-59-0{margin-left:0}
.mt20{margin-top:15px}
.display{display:block}
.mt100{margin-top:50px;}
.mt240{top:120px}
.mt300{top:180px}

.left200{left:0px !important}
.height240{
	height:120px !important
}

}
>>>.el-submenu .el-menu-item{
	font-size:13px !important
}
>>>.el-main{padding:20px 10px !important}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue